// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2lxmM","noInteraction":"EventWrapper_noInteraction__31bUd","pointerPassthrough":"EventWrapper_pointerPassthrough__ucQWE"};